
import { computed, defineComponent } from 'vue';

import { useRoute } from 'vue-router';

import NextFrame from '@/components/NextFrame.vue';

export default defineComponent({
  components: {
    NextFrame,
  },
  setup() {
    const route = useRoute();

    const path = computed(() => (route.params.id ? `/funnels/${route.params.id}` : '/funnels'));

    return {
      path,
    };
  },
});
